import React, { useState } from "react";

import { DashboardLayoutType } from "api/model/dashboard/DashboardComponent";
import {
  DashboardComponentAlign,
  DashboardComponentGroupLayout,
  DashboardComponentJustify,
} from "api/model/dashboard/DashboardComponentGroup";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { T } from "services/lang/LanguageService";

type GroupLayoutConfigurationType = {
  layout: DashboardComponentGroupLayout;
  onChange: (newGroup: DashboardComponentGroupLayout) => void;
  closeDialog: () => void;
};

const GroupLayoutConfiguration: React.FC<GroupLayoutConfigurationType> = ({
  layout,
  onChange,
  closeDialog,
}) => {
  const [type, setType] = useState<DashboardLayoutType | undefined>(layout.type);

  const [gap, setGap] = useState<number | null>(layout.gap || 2);
  const [justify, setJustify] = useState<DashboardComponentJustify>(
    layout.justify || DashboardComponentJustify.BETWEEN
  );
  const [align, setAlign] = useState<DashboardComponentAlign>(layout.align || DashboardComponentAlign.CENTER);

  const typeOptions = Object.values(DashboardLayoutType).map(layoutType => ({
    label: layoutType,
    value: layoutType,
  }));

  const justifyOptions = Object.values(DashboardComponentJustify).map(justifyType => ({
    label: justifyType,
    value: justifyType,
  }));

  const alignOptions = Object.values(DashboardComponentAlign).map(alignType => ({
    label: alignType,
    value: alignType,
  }));

  const onSaveClick = () => {
    const newLayout: DashboardComponentGroupLayout = {
      type: type || DashboardLayoutType.VERTICAL,
    };
    if (type === DashboardLayoutType.HORIZONTAL_FLEX) {
      if (align) {
        newLayout.align = align;
      }
      if (gap != null) {
        newLayout.gap = gap;
      }

      if (justify) {
        newLayout.justify = justify;
      }
    }

    onChange(newLayout);
    closeDialog();
  };

  return (
    <div className="flex flex-column gap-2">
      <div className="flex flex-column gap-1">
        <b>{T("word.type")}</b>
        <Dropdown
          value={type}
          options={typeOptions}
          onChange={(e: { value: DashboardLayoutType }) => setType(e.value)}
          placeholder={T("action.select-a-type")}
        />
      </div>

      {type === DashboardLayoutType.HORIZONTAL_FLEX && (
        <>
          <div className="flex flex-column gap-1">
            <b>{T("word.gap")}</b>
            <InputNumber value={gap} onChange={e => setGap(e.value)} min={0} max={8} maxFractionDigits={0} />
          </div>

          <div className="flex flex-column gap-1">
            <b>{T("word.justify")}</b>
            <Dropdown
              value={justify}
              options={justifyOptions}
              onChange={(e: { value: DashboardComponentJustify }) => setJustify(e.value)}
              placeholder={T("action.select-a-justify")}
            />
          </div>

          <div className="flex flex-column gap-1">
            <b>{T("word.align")}</b>
            <Dropdown
              value={align}
              options={alignOptions}
              onChange={(e: { value: DashboardComponentAlign }) => setAlign(e.value)}
              placeholder={T("action.select-a-align")}
            />
          </div>
        </>
      )}

      <div className="flex justify-content-end">
        <Button icon="pi pi-save" label={T("action.save")} onClick={() => onSaveClick()} />
      </div>
    </div>
  );
};

export default GroupLayoutConfiguration;
